import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

function TranslateButton() {
  const { language, setLanguageTo } = useLanguage();

  const handleLanguageChange = (lang) => {
    setLanguageTo(lang);
  };

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => handleLanguageChange('ka')}
        className={`px-3 py-1 text-xs font-medium rounded-md transition-colors duration-200 ${
          language === 'ka' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        GE
      </button>
      <button
        onClick={() => handleLanguageChange('en')}
        className={`px-3 py-1 text-xs font-medium rounded-md transition-colors duration-200 ${
          language === 'en' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        ENG
      </button>
    </div>
  );
}

export default TranslateButton;
